// Hook do modal CRUD de bairro (criar OU editar).
// Encapsula estado do modal, do form e do salvar/deletar.

import { useCallback, useState } from "react";
import { toast } from "sonner";
import { bairrosApi } from "../api/bairrosApi";

const formVazio = { nome: "", valor_entrega: "0", cep: "" };

export function useBairroForm({ onSucesso, cepUnico, cepUnicoValue }) {
  const [open, setOpen] = useState(false);
  const [editando, setEditando] = useState(null);
  const [formData, setFormData] = useState(formVazio);
  const [saving, setSaving] = useState(false);

  const abrir = useCallback(
    (bairro = null) => {
      if (bairro) {
        setEditando(bairro);
        setFormData({
          nome: bairro.nome,
          valor_entrega: bairro.valor_entrega?.toString() || "0",
          cep: bairro.cep || "",
        });
      } else {
        setEditando(null);
        setFormData({ ...formVazio, cep: cepUnico ? cepUnicoValue : "" });
      }
      setOpen(true);
    },
    [cepUnico, cepUnicoValue]
  );

  const fechar = useCallback(() => setOpen(false), []);

  const salvar = useCallback(async () => {
    if (!formData.nome.trim()) {
      toast.error("Digite o nome do bairro");
      return;
    }
    setSaving(true);
    try {
      const data = {
        nome: formData.nome.trim(),
        valor_entrega: parseFloat(formData.valor_entrega) || 0,
        cep: cepUnico ? cepUnicoValue : formData.cep.trim() || null,
      };
      if (editando) {
        await bairrosApi.atualizar(editando.id, data);
        toast.success("Bairro atualizado!");
      } else {
        await bairrosApi.criar(data);
        toast.success("Bairro cadastrado!");
      }
      setOpen(false);
      onSucesso?.();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao salvar bairro");
    } finally {
      setSaving(false);
    }
  }, [editando, formData, cepUnico, cepUnicoValue, onSucesso]);

  const deletar = useCallback(
    async (bairro) => {
      if (!window.confirm(`Deseja remover o bairro "${bairro.nome}"?`)) return;
      try {
        await bairrosApi.deletar(bairro.id);
        toast.success("Bairro removido!");
        onSucesso?.();
      } catch (error) {
        toast.error(error.response?.data?.detail || "Erro ao remover bairro");
      }
    },
    [onSucesso]
  );

  return { open, setOpen, editando, formData, setFormData, saving, abrir, fechar, salvar, deletar };
}
